export enum QuotaBehaviorTypes {
    NoLic = -2,
    Unlimited = -1,
    Disabled = 0,
    Block = 1,
    Ignore = 4,
}
